module.exports = __webpack_public_path__ + "rosacea_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_2_before_tn.jpg
// module id = 1448
// module chunks = 0